import React, { useEffect, useState } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import SpotlightCardItem from "./SpotlightCardItem";
import { darkTheme, lightTheme } from "../../../../theme/Theme";
import { useDispatch, useSelector } from "react-redux";
import { setDisplay } from "../../../../slices/adminPageSlice";
import useThemeRender from "../../../../theme/useThemeRender";
import ViewSummary from "../../../ViewSummary/ViewSummary";
import AlertBox from "./AlertBox";
import PropTypes from "prop-types";
import { getAPI, postAPI } from "../../../../API/ApiService";
import { BASE_URL } from "../../../../constant/apiUrl";
import Loading from "../../../../utils/Loader";
import { setSpotlight } from "../../../../slices/spotlightSlice";
import { setViewSummaryDrawer } from "../../../../slices/viewSummarySlice";
import { Button } from "pepsico-ds";
import { handleDragEnd } from "../../../../utils/function";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  arrayMove,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import SortableSpotlightItem from "./SortableSpotlightIem";
import { useNavigate } from "react-router-dom";

import axios from "axios";

export default function Spotlight({ flexDirection, width } = {}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [deleteSlotId, setDeleteSlotId] = React.useState(false);
  const [fetch, setFetch] = useState(false);
  const isDarkTheme = useSelector((state) => state.theme);
  const isMobile = useMediaQuery("(max-width: 600px)");
  const token = localStorage.getItem("auth_token");
  const [disable, setDisable] = useState(false);
  const { viewSummaryDrawer } = useSelector((store) => store.viewSummary);
  const [localSpotlight, SetLocalSpotlight] = useState([]);
  const navigate = useNavigate();
  const { spotlight } = useSelector((store) => store.spotlight);
  const insideCardBackgroundColorLayer3 = useThemeRender(
    "insideCardBackgroundColorLayer3"
  );

  useEffect(() => {
    dispatch(setDisplay(false));
    dispatch(setViewSummaryDrawer(false));
  }, [dispatch]);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const response = await getAPI(`${BASE_URL}/spotlights/find-all`);
        if (response?.status === 200) {
          const fetch = response?.data;

          if (fetch?.length >= 9) {
            setDisable(true);
          } else {
            setDisable(false);
          }
          SetLocalSpotlight(fetch);
          dispatch(setSpotlight(fetch));
        }
        if (response?.status === 400) {
          SetLocalSpotlight([]);
          dispatch(setSpotlight([]));
        }
      } catch (e) {
      } finally {
        setLoading(false);
      }
    };
    fetchAllData();
  }, [fetch, dispatch]);

  const sortedData = [...(localSpotlight || [])].sort(
    (a, b) => a.slotNumber - b.slotNumber
  );
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleNavigate = () => {
    navigate("/admin/add");
  };

  return (
    <div className="flex flex-col gap-4">
      {loading && <Loading />}
      <Box
        sx={{
          display: "flex",
          width: "100%",
          padding: "16px var(--Spacing-spacing-16, 16px)",
          flexDirection: flexDirection ? flexDirection : "column",
          alignItems: "flex-start",
          gap: "16px",
          borderRadius: "var(--Corner-radius-corner-radius-small, 8px)",
          backgroundColor: isDarkTheme
            ? darkTheme.backgroundColorLayer1
            : "#FFF",
          paddingTop: "28px",
        }}
      >
        <Typography
          sx={{
            color: isDarkTheme
              ? darkTheme.textColorLayer2
              : lightTheme.textColorLayer2,
            fontFamily: "Inter",
            fontSize: 24,
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "32px",
          }}
        >
          {` Landing page - ${localSpotlight?.length} of 9 slots filled`}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "2rem",
            flexWrap: "wrap",
          }}
        >
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={(event) =>
              handleDragEnd(
                event,
                localSpotlight,
                arrayMove,
                SetLocalSpotlight,
                setSpotlight,
                setLoading,
                dispatch,
                "/spotlights/update"
              )
            }
          >
            <SortableContext
              items={localSpotlight.map((item) => item.id)}
              strategy={verticalListSortingStrategy}
            >
              {sortedData.map((item) => (
                <SortableSpotlightItem
                  key={item.id}
                  id={item.id}
                  card={item}
                  slotNumber={item.slotNumber}
                  width={width}
                  setDeleteSlotId={setDeleteSlotId}
                />
              ))}
            </SortableContext>
          </DndContext>

          {!disable && (
            <Box
              sx={{
                display: "flex",
                width: width ? width : "397px",
                padding: "24px",
                height: "477px",
                flexDirection: "column",
                justifyContent: "center", // Centers content vertically
                alignItems: "center", // Centers content horizontally
                gap: "16px",
                borderRadius: "8px",
                background: "#FBFCFE",
                boxShadow: "0px 0px 24px 0px rgba(0, 92, 188, 0.08)",
                backgroundColor: insideCardBackgroundColorLayer3,
              }}
            >
              <Button
                text="Add content"
                variant="secondary"
                onClick={handleNavigate} //This implementation is missing
                iconTrailing="add_circle_outline"
                data-testid="add"
              />
            </Box>
          )}
          {viewSummaryDrawer && <ViewSummary />}
          <AlertBox
            deleteSlotId={deleteSlotId}
            setFetch={setFetch}
            token={token}
            action={"Remove"}
            fetch={fetch}
          />
        </Box>
      </Box>
    </div>
  );
}
Spotlight.propTypes = {
  flexDirection: PropTypes.string, // Optional string for flex direction
  width: PropTypes.string, // Optional string for width
};
